// import react from 'react'

import { MouseEventHandler } from 'react';
import { config } from '../../config';
import './switch.scss'
import { sentenceize } from '../../helpers';

type SwitchProps = {
  activeView: string
	setActiveView: (view:string) => void
};

const Switch = ({
  activeView,
  setActiveView,
}:SwitchProps) => {

  const handleSwitchClick:MouseEventHandler<HTMLAnchorElement> | undefined = (evt:React.MouseEvent) => {
    if (!evt) return false
    evt.preventDefault()
    const target = evt.target as HTMLElement

    if (!target?.dataset?.name) return
    setActiveView(target!.dataset?.name)

    return false //make sure we kill the link
  }

  const tabStub:string = 'crc-map-switch-'
  const tabList:string[] = ['map', 'list']

  return (
    <div className='nsw-tabs js-tabs crc-switch' id="crc-switch">
      <div className='nsw-tabs__list-wrapper'>
        <ul className="nsw-tabs__list" role="tablist" aria-owns={tabList.map((t:string, idx:number) => `${tabStub}${t}-${idx}`).join(' ')}>
          {tabList.map((type, idx) => {
            return (
              <li role="presentation">
                <a
                  role="tab"
                  href={`#${tabStub}${type}${idx}`}
                  id={`${tabStub}${type}-${idx}`}
                  className={`${config.namespace}-tab ${activeView === type ? 'active' : ''}`}
                  data-name={type}
                  aria-selected={activeView === type}
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleSwitchClick(e)}>
                    {`${sentenceize(type)}`} view
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Switch
